import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskDebriefCanceled_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskDebriefCanceled_ActivityLogFragment;
}

const ActivityLogTaskDebriefCanceled: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.canceledDebrief"
    />
  );
};

ActivityLogTaskDebriefCanceled.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskDebriefCanceled_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskDebriefCanceled;
